import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { categories } from "@/mocks/comics";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/category/fantasy", label: "奇幻妖精" },
  { to: "/category/isekai", label: "异世界" },
  { to: "/category/magic", label: "魔法" },
  { to: "/category/elf", label: "精灵" },
  { to: "/category/yokai", label: "妖怪" },
  { to: "/category/myth", label: "神话" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [catOpen, setCatOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/60" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="韩国妖精漫画首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-sparkling-2-fill text-lg"></i>
          </span>
          <span className="font-heading text-lg md:text-xl font-bold tracking-wide text-primary-400">
            妖精漫画
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm whitespace-nowrap transition-colors ${
                  isActive
                    ? "text-primary-400 font-medium"
                    : "text-foreground-700 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/category/fantasy"
            className="hidden md:inline-flex items-center gap-2 rounded-md bg-secondary-100 px-3 py-2 text-sm text-secondary-900 hover:bg-secondary-200 transition-colors"
          >
            <i className="ri-search-line text-sm"></i>
            <span className="whitespace-nowrap">搜漫画</span>
          </Link>
          <Link
            to="/about"
            className="hidden sm:inline-flex items-center rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
          >
            <span className="whitespace-nowrap">关于我们</span>
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
            aria-label="展开菜单"
            aria-expanded={menuOpen}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200/60 bg-background-50/95 backdrop-blur-md px-4 py-4">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm ${
                    isActive ? "bg-primary-100 text-primary-700" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <NavLink
              to="/about"
              onClick={() => setMenuOpen(false)}
              className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
            >
              关于我们
            </NavLink>
          </div>
        </div>
      )}
    </header>
  );
}